module.exports = __webpack_public_path__ + "static/media/alfa-romeo-go-drive.e00623c3.png";